import React from 'react';

export default props => {
    return <div className="SideFlag" style={{backgroundColor: props.color}}></div>;
}
